import React from "react";
import { useTranslation } from "react-i18next";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { Colors } from "@/theme";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: Colors.TABLE_HEADER1,
    color: Colors.GRAY_DARK,
    fontSize: 12,
  },
}));

const TableHeaderComponent = () => {
  const { t } = useTranslation();
  const headerCells = [
    {
      id: "date_time",
      label: t("dashboard_screen.date_time"),
      width: "40%",
      align: "left",
    },
    {
      id: "cost_price",
      label: t("dashboard_screen.cost_price"),
      width: "20%",
      align: "left",
    },
    {
      id: "sell_price",
      label: t("dashboard_screen.sell_price"),
      width: "20%",
      align: "left",
    },
    {
      id: "margin",
      label: t("dashboard_screen.margin"),
      width: "20%",
      align: "left",
    },
  ];
  return (
    <TableHead>
      <TableRow>
        {headerCells.map((cell) => (
          <StyledTableCell
            key={cell.id}
            sx={{ width: cell.width }}
            align={cell.align}
          >
            {cell.label}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeaderComponent;
